<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="保养标准" prop="maintenanceName">
              <a-input placeholder="请输入保养标准" v-model="model.maintenanceName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备类型" prop="devClassId">
              <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="model.devClassId" /> -->
              <j-tree-select
                dict="`iwt-wf`.dev_class,type_name,id"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                v-model="model.devClassId"
              ></j-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="说明" prop="content">
              <a-input placeholder="请输入说明" v-model="model.content"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <!-- 子表单区域 -->
    <a-tabs @change="handleChangeTabs" v-model="activeKey">
      <a-tab-pane :forceRender="true" :key="refKeys[0]" tab="保养项目">
        <j-editable-table
          :actionButton="true"
          :columns="devMaintenanceStlSubTable.columns"
          :dataSource="devMaintenanceStlSubTable.dataSource"
          :disabled="formDisabled"
          :loading="devMaintenanceStlSubTable.loading"
          :maxHeight="300"
          :ref="refKeys[0]"
          :rowSelection="true"
          dragSort
        />
      </a-tab-pane>
    </a-tabs>
  </a-spin>
</template>

<script>

  import { getAction } from '@/api/manage'
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'DevMaintenanceStlForm',
    mixins: [JEditableTableModelMixin],
    components: {
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        model: {
        },
        // 新增时子表默认添加几行空数据
        addDefaultRowNum: 1,
        validatorRules: {
        },
        refKeys: ['devMaintenanceStlSub',],
        tableKeys: ['devMaintenanceStlSub',],
        activeKey: 'devMaintenanceStlSub',
        // 保养项目
        devMaintenanceStlSubTable: {
          loading: false,
          dataSource: [],
          columns: [

            {
              title: '项目名称',
              key: 'projectName',
              type: FormTypes.input,
              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '保养操作',
              key: 'maintenanceOperate',
              type: FormTypes.input,

              placeholder: '请输入${title}',
              defaultValue: '',
            },
            {
              title: '保养部位',
              key: 'maintenancePlace',
              type: FormTypes.input,
              placeholder: '请输入${title}',
              defaultValue: '',
            },

          ]
        },
        url: {
          add: "/maintenance/devMaintenanceStl/add",
          edit: "/maintenance/devMaintenanceStl/edit",
          queryById: "/maintenance/devMaintenanceStl/queryById",
          devMaintenanceStlSub: {
            list: '/maintenance/devMaintenanceStl/queryDevMaintenanceStlSubByMainId'
          },
        },
      }
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
    },
    methods: {
      addBefore () {
        this.devMaintenanceStlSubTable.dataSource = []
      },
      getAllTable () {
        let values = this.tableKeys.map(key => getRefPromise(this, key))
        return Promise.all(values)
      },
      /** 调用完edit()方法之后会自动调用此方法 */
      editAfter () {
        this.$nextTick(() => {
        })
        // 加载子表数据
        if (this.model.id) {
          let params = { id: this.model.id }
          this.requestSubTableData(this.url.devMaintenanceStlSub.list, params, this.devMaintenanceStlSubTable)
        }
      },
      //校验所有一对一子表表单
      validateSubForm (allValues) {
        return new Promise((resolve, reject) => {
          Promise.all([
          ]).then(() => {
            resolve(allValues)
          }).catch(e => {
            if (e.error === VALIDATE_NO_PASSED) {
              // 如果有未通过表单验证的子表，就自动跳转到它所在的tab
              this.activeKey = e.index == null ? this.activeKey : this.refKeys[e.index]
            } else {
              console.error(e)
            }
          })
        })
      },
      /** 整理成formData */
      classifyIntoFormData (allValues) {
        let main = Object.assign(this.model, allValues.formValue)
        const tableValues = allValues.tablesValue[0].values.map(item => {
          item.devClassId = this.model.devClassId
          return item
        })
        return {
          ...main, // 展开
          devMaintenanceStlSubList: tableValues
        }
      },
      validateError (msg) {
        this.$message.error(msg)
      },

    }
  }
</script>

<style scoped>


</style>